"use client";

import { AppOptionType } from "@/models";
import { InputLabelProps, SelectChangeEvent, SelectProps } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import {
  Control,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import AppFormControlSelect from "../AppFormControlSelect";

const AppFormControlSpecificSelect = <T extends FieldValues>({
  options,
  label,
  control,
  name,
  rules,
  labelProps,
  selectProps,
  onChangeValueForm,
  helper,
  getOptions,
}: AppFormControlSpecificSelectProps<T>) => {
  const [selectOptions, setSelectOptions] = useState<AppOptionType[]>([]);
  const [isLoading, setIsLoading] = useState(!Boolean(options));

  useEffect(() => {
    if (options) {
      setSelectOptions(options || []);
      setIsLoading(false);
    } else if (getOptions) {
      setIsLoading(true);
      getOptions().then((ops) => {
        setIsLoading(false);
        setSelectOptions(ops);
      });
    } else {
      setSelectOptions([]);
    }
  }, [options, getOptions]);

  return (
    <AppFormControlSelect
      label={label}
      control={control}
      name={name}
      rules={rules}
      options={selectOptions || []}
      labelProps={labelProps}
      selectProps={selectProps}
      isLoading={isLoading}
      onChangeValueForm={onChangeValueForm}
      helper={helper}
    />
  );
};

export default AppFormControlSpecificSelect;

export type AppFormControlSpecificSelectProps<T extends FieldValues> = {
  options?: AppOptionType[];
  label?: string | ReactNode;
  control: Control<T>;
  name: FieldPath<T>;
  rules?: RegisterOptions;
  labelProps?: InputLabelProps;
  selectProps?: SelectProps;
  onChangeValueForm?: (event?: SelectChangeEvent<unknown>) => void;
  helper?: string | ReactNode;
  getOptions?: () => Promise<AppOptionType[]>;
};
